import Api from "./api";

class PostApi {
    api = new Api()

    /**
     * @return {Promise<{value: string, label: string}>}
     */
    getPostTypes() {
        return this.api.get('/zen/posts/types')
    }
}

export default new PostApi();
